module.exports = __webpack_public_path__ + "img/team4.df8bf46b.png";